import { useEffect } from 'react';

declare global {
    interface Window {
        OnetrustActiveGroups?: string;
        Optanon?: {
            RefreshConsentUI?: () => void;
            // You can add more OneTrust properties here if needed
        };
        OptanonWrapper?: () => void;
    }
}

const OneTrust = () => {
    const scriptId = 'ot-sdk-script';

    useEffect(() => {
        const { hostname } = window.location;

        const allowedHosts = [
            'emp.row.fragomenworkright.com',
            'emp.row.fragomenworkright',
        ];

        const isAllowedHost = allowedHosts.includes(hostname);

        if (!isAllowedHost) return;

        if (document.getElementById(scriptId)) return;

        const script = document.createElement('script');
        script.id = scriptId;
        script.type = 'text/javascript';
        script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
        script.setAttribute('data-domain-script', '0196c8f2-09a8-7e3f-986b-ab0f72f924fb');
        script.async = true;

        script.onload = () => {
            // @ts-ignore
            window.OptanonWrapper = () => {
                // Optional: run code after OneTrust loads
            };
        };

        script.onerror = () => {
            console.error('Failed to load OneTrust script.');
        };

        document.head.appendChild(script);


    }, []);

    useEffect(() => {
        if (window.OnetrustActiveGroups || window.Optanon) {
            window.Optanon?.RefreshConsentUI?.();
        }
    }, []);

    return null;
};

export default OneTrust;